export const setSections = (sections) => { return { type: 'SET_SECTIONS', payload: sections } }

export const changeSection = (section) => { return { type: 'CHANGE_SECTION', payload: section } }

export const setIsChangeMode = (isChangeMode) => { return { type: 'SET_IS_CHANGE_MODE', payload: isChangeMode } }

export const setSectionField = (title_key, fieldName, value) => { return { type: "SET_SECTION_FIELD", payload: {title_key, fieldName, value} } }